export default __webpack_public_path__ + "assets/size_icon.svg";